<section id="top-bar" class="border-b theme-border">
    <div class="flex flex-col gap-1">
        <div class="text-2xl font-bold theme-text">
            {{ header() }}
        </div>
        @if (description()) {
            <div class="flex text-sm description">
                {{ description() }}
            </div>
        }
    </div>
    <ng-container *ngTemplateOutlet="suffixSection" />
</section>

<ng-template #suffixSection>
    <div class="flex gap-3 items-center select-none">
        <div class="flex gap-3 items-center">
            @if (admin()?.profileImage?.url; as image) {
                <div
                    class="flex overflow-hidden justify-center items-center rounded-full border border-gray-200 size-10"
                >
                    <img [src]="image" />
                </div>
            } @else {
                <app-icon
                    name="material-symbols:person"
                    class="text-gray-800"
                />
            }
            <p class="text-gray-800">{{ admin()?.name }}</p>
        </div>
        <div class="flex gap-3 items-center">
            <app-icon-button (click)="toggleMasking()">
                <div class="flex gap-2 items-center">
                    <app-icon
                        [name]="
                            maskingStore.isMaskingEnabled()
                                ? 'material-symbols:visibility-off'
                                : 'material-symbols:visibility'
                        "
                        [class.text-red-500]="!maskingStore.isMaskingEnabled()"
                    />
                    <p
                        [class.text-red-500]="!maskingStore.isMaskingEnabled()"
                        class="text-gray-800"
                    >
                        {{
                            maskingStore.isMaskingEnabled()
                                ? "마스킹 해제"
                                : "마스킹 적용"
                        }}
                    </p>
                </div>
            </app-icon-button>
        </div>
        <div class="ml-1 w-px h-4 bg-gray-300"></div>
        <!-- <app-icon-button
            (click)="toggleTheme()"
            [icon]="
                theme() === 'dark'
                    ? 'material-symbols-light:dark-mode-rounded'
                    : 'ic:baseline-light-mode'
            "
        /> -->
        <app-icon-button (click)="logout()">
            <div class="flex gap-2 items-center">
                <app-icon name="mdi:logout" />
                <p class="text-gray-800">로그아웃</p>
            </div>
        </app-icon-button>
    </div>
</ng-template>
